import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _CREDIT_AGENCIES_INTE, _CREDIT_AGENCY_VS_ECO;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { createSelector, defaultMemoize } from 'reselect'; // import _property from 'lodash/property';

import _get from 'lodash/get';
import _flattenDeep from 'lodash/flattenDeep';
import _isEmpty from 'lodash/isEmpty';
import _pickBy from 'lodash/pickBy';
import _values from 'lodash/values';
import _sortBy from 'lodash/sortBy';
import _pick from 'lodash/pick';
import _keys from 'lodash/keys';
import _compact from 'lodash/compact';
import _forEach from 'lodash/forEach';
import _filter from 'lodash/filter';
import _keyBy from 'lodash/keyBy';
import _includes from 'lodash/includes';
import _invert from 'lodash/invert';
import _find from 'lodash/find';
import TEnvReader from '../../readers/Env';
import { EMPTY_ARRAY, EMPTY_OBJECT, EMPTY_STRING } from '../../app.constants';
import { CREDIT_AGENCIES } from '../../constants/retail/credit.constants';
import { INTEGRATION_KEYS } from '../../constants/retail/salesSetup.constants';
import { DEAL_STATUS_CONFIGS, DEAL_STATUS_TABLE_IDS } from '../../constants/retail/dealStatusConfigs.constants';
import { MSStateID } from '../constants/marketScan.constants';
import { TRADE_IN_MIN_VALUE, VEHICLE_TYPE, DEMO_MILEAGE_ADJUSTMENT_TYPES, DEAL_TYPE, INCLUDE_OPERATOR } from '../constants/constants';
import { PAYMENT_TYPES, TAX_AND_ZIP_CODE_DETAILS_VS_KEY, PAYMENT_FREQUENCY } from '../constants/desking.constants';
import { LENDER_PAYMENT_FIELDS, MORE_FIELDS } from '../constants/deskingFields.constants';
import { getSplitStateTaxConfigs, getMergedStateTaxConfigs } from '../utils/taxConfig.utils';
var LOAN = PAYMENT_TYPES.LOAN,
    LEASE = PAYMENT_TYPES.LEASE,
    CASH = PAYMENT_TYPES.CASH,
    ONE_TIME_LEASE = PAYMENT_TYPES.ONE_TIME_LEASE,
    BALLOON = PAYMENT_TYPES.BALLOON;
var OUT_OF_STATE_TAX = INTEGRATION_KEYS.OUT_OF_STATE_TAX,
    REBATE_TAX_TYPES = INTEGRATION_KEYS.REBATE_TAX_TYPES,
    MULTIPLE_DOWNPAYMENTS = INTEGRATION_KEYS.MULTIPLE_DOWNPAYMENTS,
    SEVEN_HUNDRED_CREDIT = INTEGRATION_KEYS.SEVEN_HUNDRED_CREDIT,
    CREDIT_APP_ROUTE_ONE = INTEGRATION_KEYS.CREDIT_APP_ROUTE_ONE,
    CREDIT_APP_CUDL = INTEGRATION_KEYS.CREDIT_APP_CUDL,
    E_CONTRACT_ROUTE_ONE = INTEGRATION_KEYS.E_CONTRACT_ROUTE_ONE,
    VIN_SOLUTIONS = INTEGRATION_KEYS.VIN_SOLUTIONS,
    V_AUTO = INTEGRATION_KEYS.V_AUTO,
    DMVDESK = INTEGRATION_KEYS.DMVDESK,
    VEHICLE_INVENTORY_UPDATE_SERVICE = INTEGRATION_KEYS.VEHICLE_INVENTORY_UPDATE_SERVICE,
    VEHICLE_INVOICE_SERVICE = INTEGRATION_KEYS.VEHICLE_INVOICE_SERVICE,
    PEN = INTEGRATION_KEYS.PEN,
    ADD_BDC_USERS_IN_DEAL = INTEGRATION_KEYS.ADD_BDC_USERS_IN_DEAL,
    CERTIFICATE_REBATES = INTEGRATION_KEYS.CERTIFICATE_REBATES,
    AUDIT = INTEGRATION_KEYS.AUDIT,
    CONCIERGE = INTEGRATION_KEYS.CONCIERGE,
    RESIDUALIZE_ACCESSORIES = INTEGRATION_KEYS.RESIDUALIZE_ACCESSORIES,
    CROSS_DEALERSHIP_INFORMATION = INTEGRATION_KEYS.CROSS_DEALERSHIP_INFORMATION,
    VW_CREDIT = INTEGRATION_KEYS.VW_CREDIT,
    AUDI_FINANCIAL_SERVICES = INTEGRATION_KEYS.AUDI_FINANCIAL_SERVICES,
    MERCEDES_FINANCIAL_SERVICES = INTEGRATION_KEYS.MERCEDES_FINANCIAL_SERVICES,
    CREDIT_DEALER_TRACK = INTEGRATION_KEYS.DEALER_TRACK,
    USED_VEHICLE_PROVIDER_DETAILS = INTEGRATION_KEYS.USED_VEHICLE_PROVIDER_DETAILS,
    E_CONTRACT_VCI = INTEGRATION_KEYS.E_CONTRACT_VCI,
    E_CONTRACT_AUDI_FINANCIAL = INTEGRATION_KEYS.E_CONTRACT_AUDI_FINANCIAL,
    E_CONTRACT_MBFS = INTEGRATION_KEYS.E_CONTRACT_MBFS,
    E_CONTRACT_BMWFS = INTEGRATION_KEYS.E_CONTRACT_BMWFS,
    VEHICLE_BUILDER_CONFIGS = INTEGRATION_KEYS.VEHICLE_BUILDER_CONFIGS;
var CREDIT_AGENCIES_INTEGRATION_MAPPER = (_CREDIT_AGENCIES_INTE = {}, _defineProperty(_CREDIT_AGENCIES_INTE, CREDIT_APP_ROUTE_ONE, CREDIT_AGENCIES.ROUTEONE), _defineProperty(_CREDIT_AGENCIES_INTE, CREDIT_APP_CUDL, CREDIT_AGENCIES.CUDL), _defineProperty(_CREDIT_AGENCIES_INTE, VW_CREDIT, CREDIT_AGENCIES.VW_CREDIT), _defineProperty(_CREDIT_AGENCIES_INTE, AUDI_FINANCIAL_SERVICES, CREDIT_AGENCIES.AUDI_FINANCIAL_SERVICES), _defineProperty(_CREDIT_AGENCIES_INTE, MERCEDES_FINANCIAL_SERVICES, CREDIT_AGENCIES.MERCEDES_BENZ_FINANCIAL_SERVICES), _defineProperty(_CREDIT_AGENCIES_INTE, CREDIT_DEALER_TRACK, CREDIT_AGENCIES.DEALER_TRACK), _CREDIT_AGENCIES_INTE);
var CREDIT_AGENCY_VS_ECONTRACT_MAPPER = (_CREDIT_AGENCY_VS_ECO = {}, _defineProperty(_CREDIT_AGENCY_VS_ECO, CREDIT_AGENCIES.VW_CREDIT, E_CONTRACT_VCI), _defineProperty(_CREDIT_AGENCY_VS_ECO, CREDIT_AGENCIES.AUDI_FINANCIAL_SERVICES, E_CONTRACT_AUDI_FINANCIAL), _defineProperty(_CREDIT_AGENCY_VS_ECO, CREDIT_AGENCIES.MERCEDES_BENZ_FINANCIAL_SERVICES, E_CONTRACT_MBFS), _defineProperty(_CREDIT_AGENCY_VS_ECO, CREDIT_AGENCIES.BMW_FINANCIAL_SERVICES, E_CONTRACT_BMWFS), _defineProperty(_CREDIT_AGENCY_VS_ECO, CREDIT_AGENCIES.ROUTEONE, E_CONTRACT_ROUTE_ONE), _CREDIT_AGENCY_VS_ECO);
export var getDealerZipCode = function getDealerZipCode(setup) {
  return _get(setup, 'customerConfig.zipCode');
};
export var getDealerMarketId = function getDealerMarketId(setup) {
  return _get(setup, 'customerConfig.dealerMarketId');
};
export var getDealerStateCode = function getDealerStateCode(setup) {
  return _get(setup, 'customerConfig.dealerStateCode');
};
export var getAnnualMiles = function getAnnualMiles(setup) {
  return _get(setup, 'dealConfig.annualMiles');
};
export var getDepositDisabledVehicleStatuses = function getDepositDisabledVehicleStatuses(setup) {
  return _get(setup, 'dealConfig.depositDisabledVehicleStatus') || [];
};
export var getDealerDownpayments = function getDealerDownpayments(setup) {
  return _get(setup, 'downPaymentConfigs');
};
export var getDealerCreditCode = function getDealerCreditCode(setup) {
  return _get(setup, 'customerConfig.creditScore');
};
export var getDealerWebsiteUris = function getDealerWebsiteUris(setup) {
  return _get(setup, 'websiteurls');
};
export var getWorkingCashConfigs = function getWorkingCashConfigs(setup) {
  return _get(setup, 'workingCashConfig');
};
export var getCashDeficiencyAutoRoll = function getCashDeficiencyAutoRoll(setup) {
  return _get(setup, 'cashDeficiencyAutoRoll');
};
export var getDefaultAutoRollCashDeficiency = function getDefaultAutoRollCashDeficiency(setup) {
  return _get(setup, 'defaultAutoRollCashDeficiency');
};
export var getAprAutoRoll = function getAprAutoRoll(setup) {
  return _get(setup, 'aprAutoRoll');
};
export var getGeneralTaxFeeSettings = function getGeneralTaxFeeSettings(setup) {
  return _get(setup, 'generalConfig');
};
export var getEnableAutoCostAdjForRO = function getEnableAutoCostAdjForRO(setup) {
  return _get(setup, 'enableAutoCostAdjForRO');
};
export var getComissionSplittype = function getComissionSplittype(setup) {
  return _get(setup, 'comissionSplittype');
};
export var getUnitCountSplittype = function getUnitCountSplittype(setup) {
  return _get(setup, 'unitCountSplitType');
};
export var getOwnerType = function getOwnerType(setup) {
  return _get(setup, 'ownerType');
};
export var getEnableBudgetBasedRecommendationInDeals = function getEnableBudgetBasedRecommendationInDeals(setup) {
  return _get(setup, 'enableBudgetBasedRecommendationInDeals');
};
export var getEnableAutoCostAdjForPO = function getEnableAutoCostAdjForPO(setup) {
  return _get(setup, 'enableAutoCostAdjForPO');
};
export var getVehicleSubtypeForNewProgram = function getVehicleSubtypeForNewProgram(setup) {
  return _get(setup, 'usedVehicleSubTypesEligibleForNewVehicleProgram');
};
export var getTaxCodeMandatoryAfterDealStatus = function getTaxCodeMandatoryAfterDealStatus(setup) {
  return _get(setup, 'taxCodeMandatoryAfterDealStatus');
};
export var getViewDemoMileageAdjustmentAs = function getViewDemoMileageAdjustmentAs(setup) {
  return _get(setup, 'viewDemoMileageAdjustmentAs');
};
export var getUseDealerZipMarketID = function getUseDealerZipMarketID(setup) {
  return _get(setup, 'useDealerZipMarketID');
};
export var getCollectTaxOnOutOfStateDeals = function getCollectTaxOnOutOfStateDeals(setup) {
  return _get(setup, ['generalConfig', 'collectTaxOnOutOfStateDeals']);
};
export var getUseCustomerTierForLoanApr = function getUseCustomerTierForLoanApr(setup) {
  return _get(setup, 'useCustomerTierForLoanApr');
};
export var getIncludeExpiredPrograms = function getIncludeExpiredPrograms(setup) {
  return _get(setup, 'includeExpiredPrograms');
};
export var getIsMultiVehicleDesking = function getIsMultiVehicleDesking(setup) {
  return _get(setup, 'multiVehicleDesking');
};
export var getIsDeferredPaymentEnabled = function getIsDeferredPaymentEnabled(setup) {
  return _get(setup, 'enableDeferredPaymentOptions');
};
export var isReserveAndSoldVehicleSelectionAllowed = function isReserveAndSoldVehicleSelectionAllowed(setup) {
  return _get(setup, 'allowReserveAndSoldVehicleSelection');
};
export var getAutocalculatecommisonforBookedandClosedDeals = function getAutocalculatecommisonforBookedandClosedDeals(setup) {
  return _get(setup, 'autocalculatecommisonforBookedandClosedDeals');
};
export function getIntegrations(setup) {
  var integrations = _get(setup, 'integrations') || EMPTY_OBJECT;
  return integrations;
}
export var getDefaultssheetConfigs = function getDefaultssheetConfigs(setup) {
  return _get(setup, 'sheetConfigs') || EMPTY_OBJECT;
};
export var getTradeInCount = function getTradeInCount(setup) {
  return _get(setup, 'noOfTradeIns') || TRADE_IN_MIN_VALUE;
};
export var getAlwaysUseDealerZipInDeal = function getAlwaysUseDealerZipInDeal(setup) {
  return _get(setup, 'alwaysUseDealerZipInDeal') || false;
};
export var getSetupFees = function getSetupFees(setup) {
  return _get(setup, 'feeConfigs') || EMPTY_ARRAY;
};
export var getDealerFNIs = function getDealerFNIs(setup) {
  return _get(setup, 'fnIConfigs') || EMPTY_ARRAY;
};
export var getDueBills = function getDueBills(setup) {
  return _get(setup, 'dueBills') || EMPTY_ARRAY;
};
export var getCostAdjustments = function getCostAdjustments(setup) {
  return _get(setup, 'costAdjustments') || EMPTY_ARRAY;
};
export var getDealTypes = function getDealTypes(setup) {
  return _get(setup, 'dealTypeConfigs') || EMPTY_ARRAY;
};
export var isDealStatusEnabled = function isDealStatusEnabled(setup, newStatus) {
  var dealStatuses = _get(setup, DEAL_STATUS_CONFIGS) || EMPTY_ARRAY;

  if (_isEmpty(dealStatuses)) {
    return true;
  }

  var statusObj = _find(dealStatuses, _defineProperty({}, DEAL_STATUS_TABLE_IDS.STATUS_KEY, newStatus)) || EMPTY_OBJECT;
  return statusObj === null || statusObj === void 0 ? void 0 : statusObj.enabled;
};
export var getDeskingFields = function getDeskingFields(setup) {
  return _get(setup, 'deskingFieldConfigs') || EMPTY_ARRAY;
};
export var getStateFeeConfig = function getStateFeeConfig(setup) {
  return _get(setup, 'stateFeeConfigV2') || EMPTY_ARRAY;
};
export var getStateTaxConfig = function getStateTaxConfig(setup) {
  return _get(setup, 'stateTaxConfigV2') || EMPTY_OBJECT;
};
export var getLenderConfigs = function getLenderConfigs(setup) {
  return _get(setup, 'lenderConfigs') || EMPTY_ARRAY;
};
export var filterDealerFNIs = function filterDealerFNIs(fniConfigs, _ref) {
  var dealType = _ref.dealType;
  return _filter(fniConfigs, function (fniConfig) {
    var targetingParams = _get(fniConfig, 'targetingParams') || [];
    var doesSatisfyTargetingParams = true;
    targetingParams.forEach(function (tparam) {
      var attribute = tparam.attribute,
          operator = tparam.operator;

      if (attribute === DEAL_TYPE && operator === INCLUDE_OPERATOR) {
        var allowedDealTypes = _get(tparam, 'values') || [];

        if (!_includes(allowedDealTypes, dealType)) {
          doesSatisfyTargetingParams = false;
        }
      }
    });
    return doesSatisfyTargetingParams;
  });
};
export var formatDealerFNIs = function formatDealerFNIs(fniConfigs) {
  var _fniConfigPaymentType;

  var fniConfigPaymentTypes = (_fniConfigPaymentType = {}, _defineProperty(_fniConfigPaymentType, LEASE, []), _defineProperty(_fniConfigPaymentType, LOAN, []), _defineProperty(_fniConfigPaymentType, CASH, []), _defineProperty(_fniConfigPaymentType, ONE_TIME_LEASE, []), _defineProperty(_fniConfigPaymentType, BALLOON, []), _fniConfigPaymentType);
  var penProducts = [];
  var fniAttributesArray = fniConfigs.map(function (_ref2) {
    var fniAttributeIds = _ref2.fniAttributeIds;
    return fniAttributeIds || EMPTY_ARRAY;
  });
  fniConfigs.forEach(function (fniConfig) {
    var fniAttributeIds = _get(fniConfig, 'fniAttributeIds') || EMPTY_ARRAY;
    var providerInfo = _get(fniConfig, 'providerInfo') || EMPTY_ARRAY;

    if (!_isEmpty(fniAttributeIds)) {
      fniConfigPaymentTypes[LEASE].push(fniAttributeIds);
      fniConfigPaymentTypes[LOAN].push(fniAttributeIds);
      fniConfigPaymentTypes[CASH].push(fniAttributeIds);
      fniConfigPaymentTypes[ONE_TIME_LEASE].push(fniAttributeIds);
      fniConfigPaymentTypes[BALLOON].push(fniAttributeIds);
    }

    penProducts.push.apply(penProducts, _toConsumableArray(providerInfo));
  });
  return {
    allFNICodes: _flattenDeep(fniAttributesArray),
    fniCodesForPaymentTypes: fniConfigPaymentTypes,
    penProducts: penProducts
  };
};
export var selectDealerCreditScore = createSelector(getDealerCreditCode, function (creditScore) {
  return creditScore || EMPTY_STRING;
});
export var selectDealerWebsiteUris = createSelector(getDealerWebsiteUris, function (websiteurls) {
  return websiteurls || EMPTY_OBJECT;
});
export var selectYearlyMiles = createSelector(getAnnualMiles, function (annualMiles) {
  return annualMiles || EMPTY_STRING;
});
export var generalTaxFeeSettings = createSelector(getGeneralTaxFeeSettings, function (generalTaxFeeSettingsData) {
  return generalTaxFeeSettingsData || EMPTY_OBJECT;
});
export var selectDealerFNIs = createSelector(getDealerFNIs, function (fniConfigs) {
  return formatDealerFNIs(fniConfigs) || EMPTY_OBJECT;
});
export var selectDefaultDownpayments = createSelector(getDealerDownpayments, function (dealerDownpayments) {
  return dealerDownpayments || EMPTY_ARRAY;
});
export var formatDeskingFields = function formatDeskingFields(deskingFieldsConfigs) {
  var deskingFields = {};
  deskingFieldsConfigs.forEach(function (dfc) {
    var deskingFieldType = _get(dfc, 'deskingFieldType') || '';
    var displayName = _get(dfc, 'displayName') || '';
    var isEnabled = _get(dfc, 'enabled') || false;

    if (isEnabled && deskingFieldType) {
      deskingFields[deskingFieldType] = displayName;
    }
  });
  return deskingFields;
};
export var formatDealTypes = function formatDealTypes(dealTypeConfigs) {
  var dealTypes = [];
  dealTypeConfigs.forEach(function (dT) {
    var dealType = dT.dealType,
        displayName = dT.displayName,
        enabled = dT.enabled;

    if (enabled) {
      dealTypes.push({
        label: displayName,
        value: dealType
      });
    }
  });
  return dealTypes;
};

var getOrderedListBySection = function getOrderedListBySection(deskingFields) {
  var LENDER_PAYMENT_SECTION = _sortBy(_pickBy(deskingFields, function (field) {
    return _values(LENDER_PAYMENT_FIELDS).includes(field.deskingFieldType);
  }), ['order']).map(function (field) {
    return field.deskingFieldType;
  });

  var MORE_FIELDS_SECTION = _sortBy(_pickBy(deskingFields, function (field) {
    return _values(MORE_FIELDS).includes(field.deskingFieldType);
  }), ['order']).map(function (field) {
    return field.deskingFieldType;
  });

  return {
    LENDER_PAYMENT_SECTION: LENDER_PAYMENT_SECTION,
    MORE_FIELDS_SECTION: MORE_FIELDS_SECTION
  };
};

export var selectDealTypes = createSelector(getDealTypes, function (dealTypes) {
  return formatDealTypes(dealTypes) || EMPTY_ARRAY;
});
export var selectDeskingFields = createSelector(getDeskingFields, function (deskingFields) {
  return formatDeskingFields(deskingFields) || EMPTY_OBJECT;
});
export var selectDeskingFieldsOrderInfo = createSelector(getDeskingFields, function (deskingFields) {
  return getOrderedListBySection(deskingFields) || EMPTY_OBJECT;
});
export var selectWorkingCashConfigs = createSelector(getWorkingCashConfigs, function (workinngCashConfigs) {
  return workinngCashConfigs || EMPTY_OBJECT;
});
export var selectCashDeficiencyAutoRoll = createSelector(getCashDeficiencyAutoRoll, function (cashDeficiencyAutoRoll) {
  return cashDeficiencyAutoRoll || false;
});
export var selectDefaultAutoRollCashDeficiency = createSelector(getDefaultAutoRollCashDeficiency, function (defaultAutoRollCashDeficiency) {
  return defaultAutoRollCashDeficiency || EMPTY_STRING;
});
export var selectZeroPercentAprAutoRoll = createSelector(getAprAutoRoll, function (aprAutoRoll) {
  return aprAutoRoll || false;
});
export var selectEnableAutoCostAdjForRO = createSelector(getEnableAutoCostAdjForRO, function (roEnabled) {
  return roEnabled || false;
});
export var selectEnableAutoCostAdjForPO = createSelector(getEnableAutoCostAdjForPO, function (poEnabled) {
  return poEnabled || false;
});
export var selectVehicleSubtypeForNewProgram = createSelector(getVehicleSubtypeForNewProgram, function (usedVehicleSubTypesEligibleForNewVehicleProgram) {
  return usedVehicleSubTypesEligibleForNewVehicleProgram || EMPTY_ARRAY;
});
export var selectTaxCodeMandatoryAfterDealStatus = createSelector(getTaxCodeMandatoryAfterDealStatus, function (taxCodeMandatoryAfterDealStatus) {
  return taxCodeMandatoryAfterDealStatus || EMPTY_STRING;
});
export var selectViewDemoMileageAdjustmentAs = createSelector(getViewDemoMileageAdjustmentAs, function (viewDemoMileageAdjustmentAs) {
  return viewDemoMileageAdjustmentAs || DEMO_MILEAGE_ADJUSTMENT_TYPES.CHECKBOX;
});
export var selectEnableBudgetBasedRecommendationInDeals = createSelector(getEnableBudgetBasedRecommendationInDeals, function (enabled) {
  return enabled || false;
});
export var getLoanFrequency = function getLoanFrequency(setup) {
  return _get(setup, 'paymentFrequencyConfig.loanFrequency');
};
export var getLeaseFrequency = function getLeaseFrequency(setup) {
  return _get(setup, 'paymentFrequencyConfig.leaseFrequency');
};
export var getDaystoFirstPayment = function getDaystoFirstPayment(setup) {
  return _get(setup, 'paymentFrequencyConfig.daysToFirstPayment') || EMPTY_ARRAY;
};
export var getDaysToFirstPaymentForLoan = function getDaysToFirstPaymentForLoan(setup, paymentFrequency) {
  return _get(_find(getDaystoFirstPayment(setup), {
    paymentType: LOAN,
    frequency: paymentFrequency || getLoanFrequency(setup)
  }), 'daysToFirstPayment');
};
export var getDaysToFirstPaymentForLease = function getDaysToFirstPaymentForLease(setup, paymentFrequency) {
  return _get(_find(getDaystoFirstPayment(setup), {
    paymentType: LEASE,
    frequency: paymentFrequency || getLeaseFrequency(setup)
  }), 'daysToFirstPayment');
};

function getLoanBuyRateForNewVehicles(setup) {
  return _get(setup, 'dealConfig.loanBuyRate');
}

function getLoanBuyRateForUsedVehicles(setup) {
  return _get(setup, 'dealConfig.loanBuyRateForUsed');
}

export var selectDaysToFirstPayment = createSelector(getDaysToFirstPaymentForLoan, getDaysToFirstPaymentForLease, function (daysToFirstPaymentForLoan, daysToFirstPaymentForLease) {
  var _ref3;

  return _ref3 = {}, _defineProperty(_ref3, LOAN, daysToFirstPaymentForLoan || 0), _defineProperty(_ref3, LEASE, daysToFirstPaymentForLease || 0), _defineProperty(_ref3, ONE_TIME_LEASE, daysToFirstPaymentForLease || 0), _defineProperty(_ref3, CASH, daysToFirstPaymentForLoan || 0), _defineProperty(_ref3, BALLOON, daysToFirstPaymentForLease || 0), _ref3;
});
export var selectPaymentFrequency = createSelector(getLoanFrequency, getLeaseFrequency, function (loanFrequency, leaseFrequency) {
  var _ref4;

  return _ref4 = {}, _defineProperty(_ref4, LOAN, loanFrequency || PAYMENT_FREQUENCY.MONTHLY), _defineProperty(_ref4, LEASE, leaseFrequency || PAYMENT_FREQUENCY.MONTHLY), _defineProperty(_ref4, CASH, PAYMENT_FREQUENCY.ONE_TIME), _defineProperty(_ref4, ONE_TIME_LEASE, PAYMENT_FREQUENCY.ONE_TIME), _defineProperty(_ref4, BALLOON, leaseFrequency || PAYMENT_FREQUENCY.MONTHLY), _ref4;
});
export var selectDefaultBuyRate = createSelector(getLoanBuyRateForNewVehicles, getLoanBuyRateForUsedVehicles, function (loanBuyRateForNewVehicles, loanBuyRateForUsedVehicles) {
  var _LOAN, _BALLOON, _ref5;

  return _ref5 = {}, _defineProperty(_ref5, LOAN, (_LOAN = {}, _defineProperty(_LOAN, VEHICLE_TYPE.NEW, loanBuyRateForNewVehicles), _defineProperty(_LOAN, VEHICLE_TYPE.USED, loanBuyRateForUsedVehicles), _LOAN)), _defineProperty(_ref5, BALLOON, (_BALLOON = {}, _defineProperty(_BALLOON, VEHICLE_TYPE.NEW, loanBuyRateForNewVehicles), _defineProperty(_BALLOON, VEHICLE_TYPE.USED, loanBuyRateForUsedVehicles), _BALLOON)), _ref5;
});

function getIntegrationFlags(integrations) {
  var _ref6;

  return _ref6 = {}, _defineProperty(_ref6, OUT_OF_STATE_TAX, _get(integrations, 'outOfStateTax') || EMPTY_OBJECT), _defineProperty(_ref6, REBATE_TAX_TYPES, _get(integrations, 'enableRebateTaxType') || EMPTY_OBJECT), _defineProperty(_ref6, VIN_SOLUTIONS, _get(integrations, 'vinSolutions') || EMPTY_OBJECT), _defineProperty(_ref6, MULTIPLE_DOWNPAYMENTS, _get(integrations, 'multipleDownPayments') || EMPTY_OBJECT), _defineProperty(_ref6, SEVEN_HUNDRED_CREDIT, _get(integrations, ['creditBureau', 'sevenHundredCredit']) || EMPTY_OBJECT), _defineProperty(_ref6, CREDIT_APP_CUDL, _get(integrations, 'creditAppCudl') || EMPTY_OBJECT), _defineProperty(_ref6, CREDIT_APP_ROUTE_ONE, _get(integrations, 'creditAppRouteOne') || EMPTY_OBJECT), _defineProperty(_ref6, DMVDESK, _get(integrations, 'dmvDesk') || EMPTY_OBJECT), _defineProperty(_ref6, E_CONTRACT_ROUTE_ONE, _get(integrations, 'econtractRouteOne') || EMPTY_OBJECT), _defineProperty(_ref6, PEN, _get(integrations, 'pen') || EMPTY_OBJECT), _defineProperty(_ref6, V_AUTO, _get(integrations, 'vauto') || EMPTY_OBJECT), _defineProperty(_ref6, VEHICLE_INVENTORY_UPDATE_SERVICE, _get(integrations, 'vehicleInventoryUpdateService') || EMPTY_OBJECT), _defineProperty(_ref6, VEHICLE_INVOICE_SERVICE, _get(integrations, 'vehicleInvoiceService') || EMPTY_OBJECT), _defineProperty(_ref6, ADD_BDC_USERS_IN_DEAL, _get(integrations, 'bdcUserCommission') || EMPTY_OBJECT), _defineProperty(_ref6, CERTIFICATE_REBATES, _get(integrations, 'certificateRebates') || EMPTY_OBJECT), _defineProperty(_ref6, AUDIT, _get(integrations, 'audit') || EMPTY_OBJECT), _defineProperty(_ref6, CONCIERGE, _get(integrations, 'concierge') || EMPTY_OBJECT), _defineProperty(_ref6, CROSS_DEALERSHIP_INFORMATION, _get(integrations, 'crossDealershipInformation') || EMPTY_OBJECT), _defineProperty(_ref6, RESIDUALIZE_ACCESSORIES, _get(integrations, RESIDUALIZE_ACCESSORIES) || EMPTY_OBJECT), _defineProperty(_ref6, VW_CREDIT, _get(integrations, 'creditAppVCI') || EMPTY_OBJECT), _defineProperty(_ref6, AUDI_FINANCIAL_SERVICES, _get(integrations, 'creditAudiFinancialServices') || EMPTY_OBJECT), _defineProperty(_ref6, MERCEDES_FINANCIAL_SERVICES, _get(integrations, 'creditAppMBFS') || EMPTY_OBJECT), _defineProperty(_ref6, CREDIT_DEALER_TRACK, _get(integrations, 'creditAppDealerTrack') || EMPTY_OBJECT), _defineProperty(_ref6, USED_VEHICLE_PROVIDER_DETAILS, _get(integrations, 'usedVehicleProviderDetails') || EMPTY_OBJECT), _defineProperty(_ref6, VEHICLE_BUILDER_CONFIGS, _get(integrations, VEHICLE_BUILDER_CONFIGS) || EMPTY_OBJECT), _defineProperty(_ref6, E_CONTRACT_VCI, _get(integrations, 'econtractVCI') || EMPTY_OBJECT), _defineProperty(_ref6, E_CONTRACT_AUDI_FINANCIAL, _get(integrations, 'econtractAudiFinancialServices') || EMPTY_OBJECT), _defineProperty(_ref6, E_CONTRACT_MBFS, _get(integrations, 'econtractMBFS') || EMPTY_OBJECT), _defineProperty(_ref6, E_CONTRACT_BMWFS, _get(integrations, 'econtractBMWFinancialServices') || EMPTY_OBJECT), _ref6;
}

export function isIntegrationEnabled(integrations, type) {
  return _get(integrations, [type, 'enabled']) || false;
}
export function getIntegrationValue(integrations, type) {
  return _get(integrations, [type, 'value']) || '';
}
export var selectIntegrationKeys = createSelector(getIntegrations, function (integrations) {
  return getIntegrationFlags(integrations);
});
export var getValuationProvider = function getValuationProvider(setup) {
  return _get(setup, 'integrations.vautoAppraisal.configurations.valuationProvider');
};
export var getProvidersVehicleValue = function getProvidersVehicleValue(setup) {
  return _get(setup, 'integrations.vautoAppraisal.configurations.providersVehicleValue');
};
export var getVautoValuationProvider = function getVautoValuationProvider(salesSetupInfo) {
  var valuationProvider = getValuationProvider(salesSetupInfo);
  var vehicleProviderDetails = selectUsedVehicleProviderDetails(salesSetupInfo) || {};
  return _find(_get(vehicleProviderDetails, [USED_VEHICLE_PROVIDER_DETAILS]) || [], function (item) {
    return _get(item, 'key') === valuationProvider;
  }) || {};
};
export var getVautoProvidersVehicleValue = function getVautoProvidersVehicleValue(salesSetupInfo) {
  var providersVehicleValue = getProvidersVehicleValue(salesSetupInfo);
  var vehicleProviderDetails = getVautoValuationProvider(salesSetupInfo) || {};
  return _find(_get(vehicleProviderDetails, 'setupDetails.vehicleValues') || [], function (item) {
    return _get(item, 'key') === providersVehicleValue;
  }) || {};
};
export var selectUsedVehicleProviderDetails = createSelector(selectIntegrationKeys, function (integrationKeys) {
  var vehicleProviderDetails = _pick(integrationKeys, [USED_VEHICLE_PROVIDER_DETAILS]);

  return vehicleProviderDetails;
});
export var selectDueBills = createSelector(getDueBills, function (dueBills) {
  return dueBills || EMPTY_ARRAY;
});
export var selectCostAdjustments = createSelector(getCostAdjustments, function (costAdjustments) {
  return costAdjustments || EMPTY_ARRAY;
});
export var getEnabledCreditAgencies = createSelector(selectIntegrationKeys, function (integrationKeys) {
  var creditIntegrations = _pick(integrationKeys, [CREDIT_APP_CUDL, CREDIT_APP_ROUTE_ONE, VW_CREDIT, AUDI_FINANCIAL_SERVICES, CREDIT_DEALER_TRACK]);

  var enabledCreditIntegrations = _pickBy(creditIntegrations, function (item) {
    return item.enabled;
  });

  var keys = _keys(enabledCreditIntegrations) || EMPTY_ARRAY;
  return _compact(keys.map(function (key) {
    return CREDIT_AGENCIES_INTEGRATION_MAPPER[key];
  }));
});
export var getEnabledEcontractAgencies = createSelector(selectIntegrationKeys, function (integrationKeys) {
  var creditIntegrations = _pick(integrationKeys, [E_CONTRACT_ROUTE_ONE, E_CONTRACT_VCI, E_CONTRACT_AUDI_FINANCIAL, E_CONTRACT_MBFS, E_CONTRACT_BMWFS]);

  var enabledcontractAgencies = _pickBy(creditIntegrations, function (item) {
    return item.enabled;
  });

  var keys = _keys(enabledcontractAgencies) || EMPTY_ARRAY;

  var mapper = _invert(CREDIT_AGENCY_VS_ECONTRACT_MAPPER);

  return _compact(keys.map(function (key) {
    return mapper[key];
  }));
});
export var getEcontractAgenciesSetupInfo = createSelector(selectIntegrationKeys, function (integrationKeys) {
  var creditIntegrations = _pick(integrationKeys, [E_CONTRACT_ROUTE_ONE, E_CONTRACT_VCI, E_CONTRACT_AUDI_FINANCIAL, E_CONTRACT_MBFS, E_CONTRACT_BMWFS]);

  var mappedEcontractSetupInfos = {};

  var mapper = _invert(CREDIT_AGENCY_VS_ECONTRACT_MAPPER);

  _forEach(creditIntegrations, function (value, key) {
    mappedEcontractSetupInfos[mapper[key]] = value;
  });

  return mappedEcontractSetupInfos;
});
export var getCreditApplicationSetupInfo = createSelector(selectIntegrationKeys, function (integrationKeys) {
  var creditSetupInfos = _pick(integrationKeys, [CREDIT_APP_CUDL, CREDIT_APP_ROUTE_ONE, VW_CREDIT, AUDI_FINANCIAL_SERVICES, MERCEDES_FINANCIAL_SERVICES, CREDIT_DEALER_TRACK]);

  var mappedCreditSetupInfos = {};

  _forEach(creditSetupInfos, function (value, key) {
    var consentDetails = value.consentDetails;
    mappedCreditSetupInfos[CREDIT_AGENCIES_INTEGRATION_MAPPER[key]] = _objectSpread(_objectSpread({}, value), {}, {
      consentDetails: _filter(consentDetails, function (_ref7) {
        var dealerConsent = _ref7.dealerConsent;
        return dealerConsent;
      })
    });
  });

  return mappedCreditSetupInfos;
});
export var selectdefaultsheetConfigs = createSelector(getDefaultssheetConfigs, function (defaultsheetConfigs) {
  return defaultsheetConfigs || EMPTY_OBJECT;
});
export var getAutoRollServiceContract = function getAutoRollServiceContract(setup) {
  return _get(setup, 'autoRollServiceContract');
};
export var getAdjustSellingPriceBasedOnVehicleGross = function getAdjustSellingPriceBasedOnVehicleGross(setup) {
  return _get(setup, 'adjustSellingPriceBasedOnVehicleGross');
};
export var selectDefaultStateFeeOptions = createSelector(getStateFeeConfig, function (stateFeeConfig) {
  return stateFeeConfig;
});
export var selectDefaultStateTaxOptions = function selectDefaultStateTaxOptions(setup, isInState, taxType) {
  var isSeparateTaxEnabledInDeal = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var stateTaxConfigV2 = _get(setup, 'stateTaxConfigV2') || EMPTY_OBJECT;
  var LEASE_TYPE = TAX_AND_ZIP_CODE_DETAILS_VS_KEY.LEASE,
      RETAIL_TYPE = TAX_AND_ZIP_CODE_DETAILS_VS_KEY.RETAIL;

  var isSeperateTaxForLoanAndLease = _get(setup, ['generalConfig', 'enableSeparateTaxCalculationForRetailAndLease']);

  if (!isSeperateTaxForLoanAndLease && isSeparateTaxEnabledInDeal) {
    stateTaxConfigV2 = getSplitStateTaxConfigs(stateTaxConfigV2);
  } else if (isSeperateTaxForLoanAndLease && !isSeparateTaxEnabledInDeal) {
    stateTaxConfigV2 = getMergedStateTaxConfigs(stateTaxConfigV2);
  }

  var inStateRetail = _get(stateTaxConfigV2, 'retailInState') || EMPTY_OBJECT;
  var inStateLease = _get(stateTaxConfigV2, 'leaseInState') || EMPTY_OBJECT;
  var inOutStateRetail = _get(stateTaxConfigV2, 'retailOutState') || EMPTY_OBJECT;
  var outStateLease = _get(stateTaxConfigV2, 'leaseOutState') || EMPTY_OBJECT;
  if (isInState && (taxType === RETAIL_TYPE || !isSeparateTaxEnabledInDeal)) return inStateRetail;
  if (isInState && taxType === LEASE_TYPE) return inStateLease;
  if (!isInState && (taxType === RETAIL_TYPE || !isSeparateTaxEnabledInDeal)) return inOutStateRetail;
  if (!isInState && taxType === LEASE_TYPE) return outStateLease;
  return EMPTY_OBJECT;
};
export var isVolumeBasedCommissionEnabled = function isVolumeBasedCommissionEnabled(setup) {
  return _get(setup, 'volumeBasedCommissions');
};
export var getLenders = function getLenders(setup) {
  return _get(setup, 'lenders');
};
export var getDealSubStatusList = function getDealSubStatusList(setup) {
  return _get(setup, 'customStatuses') || EMPTY_ARRAY;
};
export var getAllDocumentTypes = function getAllDocumentTypes(setup, agency) {
  var setupKeyForAgency = _get(CREDIT_AGENCY_VS_ECONTRACT_MAPPER, [agency]);

  return _get(setup, ['integrations', setupKeyForAgency, 'documentTypes']) || EMPTY_ARRAY;
};
export var getAllContractFormConfig = function getAllContractFormConfig(setup, agency) {
  var setupKeyForAgency = _get(CREDIT_AGENCY_VS_ECONTRACT_MAPPER, [agency]);

  return _get(setup, ['integrations', setupKeyForAgency, 'formConfig']) || EMPTY_OBJECT;
};
export var getUnSolicitedDocumentTypes = createSelector(getAllDocumentTypes, function (documentTypes) {
  return _filter(documentTypes, function (document) {
    return _get(document, 'unsolicited');
  });
});
export var getRebateFields = defaultMemoize(function (setup) {
  var rebateConfigs = _get(setup, 'rebateConfigs') || [];
  return _keyBy(rebateConfigs, 'rebateField');
});
export var getRolesWithDefaultAccessToPaymentRecalculation = defaultMemoize(function (setup) {
  var rolesWithDefaultAccessToPaymentRecalculation = _get(setup, 'rolesWithDefaultAccessToPaymentRecalculation') || [];
  return rolesWithDefaultAccessToPaymentRecalculation;
});
export var canDoDefaultPaymentCalculation = function canDoDefaultPaymentCalculation(setup) {
  var loggedInUserRoleId = _get(TEnvReader.userInfo(), 'roleId');

  var rolesWithDefaultAccessToPaymentRecalculation = getRolesWithDefaultAccessToPaymentRecalculation(setup);
  return rolesWithDefaultAccessToPaymentRecalculation.includes(loggedInUserRoleId);
};
export var hasDivisionForOwnershipTypeEnabled = function hasDivisionForOwnershipTypeEnabled(state, salesSetupInfo) {
  var showDivisionForOwnershipTypeStates = _get(salesSetupInfo, ['generalConfig', 'showDivisionForOwnershipType']);

  return _includes(showDivisionForOwnershipTypeStates, MSStateID[state]);
};
export var getRegistraionFeeInCap = function getRegistraionFeeInCap(setup) {
  return _get(setup, ['generalFeeConfig', 'capRegistrationFee']) || false;
};
export var getUseHardAddNumber = function getUseHardAddNumber(setup) {
  return _get(setup, ['useHardAddNumber']) || false;
};
export var getUseHardAddNumberForFnI = function getUseHardAddNumberForFnI(setup) {
  return _get(setup, ['useHardAddNumberForFnI']) || false;
};
export var getRolesForAssignee = function getRolesForAssignee(salesSetupInfo) {
  return _get(salesSetupInfo, 'rolesForAssignee') || EMPTY_OBJECT;
};
export var isVAutoAppraisalEnabled = function isVAutoAppraisalEnabled(salesSetupInfo) {
  return _get(salesSetupInfo, 'integrations.vautoAppraisal.enabled') || false;
};
export var getDisclosureTypesWithSurtax = function getDisclosureTypesWithSurtax(salesSetupInfo) {
  return _get(salesSetupInfo, ['generalConfig', 'disclosureTypesWithSurtax']);
};
export var canUseDealershipAddressInformation = function canUseDealershipAddressInformation(salesSetupInfo) {
  return _get(salesSetupInfo, 'useDealershipAddressInformation') || false;
};
export var isVehicleLocationOverflowEnabled = function isVehicleLocationOverflowEnabled(salesSetupInfo) {
  return _get(salesSetupInfo, 'enableVehicleLocationOverflow') || false;
};
export var getDisplayModelSource = function getDisplayModelSource(salesSetupInfo) {
  return _get(salesSetupInfo, 'displayModelSource');
};
export var isUpdateTradeInValuesEnabled = function isUpdateTradeInValuesEnabled(salesSetupInfo) {
  return _get(salesSetupInfo, 'integrations.vautoAppraisal.updateDealTradeInValues') || false;
};
export var isPrecloseFlowEnabled = function isPrecloseFlowEnabled(salesSetupInfo) {
  return _get(salesSetupInfo, 'enablePreCloseWorkflow') || false;
};
export var getDefaultHeaderDate = function getDefaultHeaderDate(salesSetupInfo) {
  return _get(salesSetupInfo, 'defaultHeaderDate');
};
export var getShowAccountingDateWhileUnwinding = function getShowAccountingDateWhileUnwinding(salesSetupInfo) {
  return _get(salesSetupInfo, 'showAccountingDateWhileUnwinding') || false;
};
export var enableFniSurvey = function enableFniSurvey(salesSetupInfo) {
  return _get(salesSetupInfo, 'enableFniSurvey') || false;
};
export var isConsumerCreditApplicationEnabled = function isConsumerCreditApplicationEnabled(salesSetupInfo) {
  return _get(salesSetupInfo, 'integrations.consumerCreditApplication.enabled') || false;
};
export var getPPSAFeeYearly = function getPPSAFeeYearly(salesSetupInfo) {
  return _get(salesSetupInfo, 'ppsaConsecutiveYearFee') || 0;
};
export var getPPSAFeeFirstYear = function getPPSAFeeFirstYear(salesSetupInfo) {
  return _get(salesSetupInfo, 'ppsaFirstYearFee') || 0;
};
export var enableEffectiveInterestRate = function enableEffectiveInterestRate(salesSetupInfo) {
  return _get(salesSetupInfo, 'showEffectiveInterestRate');
};
export var showMaximumResidualMSRP = function showMaximumResidualMSRP(salesSetupInfo) {
  return _get(salesSetupInfo, 'showMaximumResidualizedMSRP');
};
export var getDefaultCounty = function getDefaultCounty(salesSetupInfo) {
  return _get(salesSetupInfo, 'customerConfig.defaultCounty') || EMPTY_OBJECT;
};
export var getAssigneeLimits = function getAssigneeLimits(salesSetupInfo) {
  return (salesSetupInfo === null || salesSetupInfo === void 0 ? void 0 : salesSetupInfo.assigneeLimits) || EMPTY_OBJECT;
};
export var getAssigneeCommissionSplitOptions = function getAssigneeCommissionSplitOptions(salesSetupInfo) {
  return (salesSetupInfo === null || salesSetupInfo === void 0 ? void 0 : salesSetupInfo.assigneeCommissionSplitOptions) || EMPTY_OBJECT;
};
export var getAssigneeUnitCountSplit = function getAssigneeUnitCountSplit(salesSetupInfo) {
  return (salesSetupInfo === null || salesSetupInfo === void 0 ? void 0 : salesSetupInfo.assigneeUnitCountSplit) || EMPTY_OBJECT;
};
export var getStateFeeTargetingConfig = function getStateFeeTargetingConfig(salesSetupInfo) {
  return (salesSetupInfo === null || salesSetupInfo === void 0 ? void 0 : salesSetupInfo.stateFeeTargetings) || EMPTY_ARRAY;
};
export var getVehicleHistoryReportAutoCheckEnabled = function getVehicleHistoryReportAutoCheckEnabled(salesSetupInfo) {
  return _get(salesSetupInfo, ['integrations', 'vehicleHistoryReportAutocheck', 'enabled']);
};
export var isOtherCreditEnquiryEnabled = function isOtherCreditEnquiryEnabled(salesSetupInfo) {
  return _get(salesSetupInfo, ['integrations', 'creditBureau', 'otherCredit', 'enabled']);
};
export var getComplianceSetups = function getComplianceSetups(salesSetupInfo) {
  return _get(salesSetupInfo, 'complianceSetups');
};
export var getFlatTaxInfo = function getFlatTaxInfo(salesSetupInfo, setupKey) {
  return _get(salesSetupInfo === null || salesSetupInfo === void 0 ? void 0 : salesSetupInfo.generalConfig, setupKey);
};
export var getShowLocationInZipCodeScreen = function getShowLocationInZipCodeScreen(salesSetupInfo) {
  var _getGeneralTaxFeeSett;

  return ((_getGeneralTaxFeeSett = getGeneralTaxFeeSettings(salesSetupInfo)) === null || _getGeneralTaxFeeSett === void 0 ? void 0 : _getGeneralTaxFeeSett.showLocationInZipCodeScreen) || [];
};
export var getEnableSendEmail = function getEnableSendEmail(salesSetupInfo) {
  return _get(salesSetupInfo, ['complianceSetups', 'enableSendEmail']);
};
export var getBureauPreferences = function getBureauPreferences(salesSetupInfo) {
  return _get(salesSetupInfo, ['complianceSetups', 'bureauPreference']);
};